import type { Action } from 'state/actions';
import { addOrReplaceKey, removeKey, removeKeys } from 'state/utils/collection';

import * as batchTypes from '../../batchForm/batchForm.actionTypes';
import type { FormDataStateMap } from '../formData.model';

export function inputReducer(state: FormDataStateMap = {}, action: Action): FormDataStateMap {
  switch (action.type) {
    case 'WORKSPACE_RESET_TAB_REQUESTED':
      return removeKey(state, action.tabId);
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'BATCH_FORMS_DELETED':
      return removeKeys(state, action.formIds);
    case 'FORM_INPUT_DATA_CHANGED':
      return addOrReplaceKey(
        state,
        action.formId,
        addOrReplaceKey(state[action.formId] || {}, action.key, action.value),
      );
    case 'FORM_ENRICHMENT_REQUESTED':
    case 'FORM_INPUT_DATA_REVERTED':
      return removeKey(state, action.formId);
    case batchTypes.DEFAULT_BATCH_FORM_RECEIVED:
      return removeKey(state, action.negotiationId);
    case batchTypes.BATCH_FORM_ENRICHMENT_FAILED:
      return addOrReplaceKey(state, action.formId, action.pendingData);
    default:
      return state;
  }
}
